import { Rule, RuleType } from "../../components/interfaces/Rule";
import { getRulesFromCustomXml, persistRulesToCustomXml } from "./CustomXmlCoRuleHelper";

export const remapScriptTagIds = (script: string, remap: Map<string, string> | Record<string, string>): string => {
  let remappedScript = script;
  if (remap instanceof Map) {
    remap.forEach((resolvedTagId, originalTagId) => {
      remappedScript = remappedScript.split(`{{${originalTagId}}}`).join(`{{${resolvedTagId}}}`);
    });
  } else {
    for (const [originalTagId, resolvedTagId] of Object.entries(remap)) {
      remappedScript = remappedScript.split(`{{${originalTagId}}}`).join(`{{${resolvedTagId}}}`);
    }
  }
  return remappedScript;
};

export const remapTagIdsInRules = (
  rules: Rule[],
  sourceTagId: string,
  destinationTagId: string
): { rules: Rule[]; changed: boolean } => {
  let changed = false;
  const remapped = rules.map((rule) => {
    if (rule.type === RuleType.CONSISTENCY) {
      const tagIds = rule.tagIds ?? [];
      if (!tagIds.includes(sourceTagId)) return rule;
      const newTagIds = [...new Set(tagIds.map((id) => (id === sourceTagId ? destinationTagId : id)))];
      changed = true;
      return { ...rule, tagIds: newTagIds };
    }
    // CUSTOM or undefined → script remap
    const newScript = rule.script.split(`{{${sourceTagId}}}`).join(`{{${destinationTagId}}}`);
    if (newScript === rule.script) return rule;
    changed = true;
    return { ...rule, script: newScript };
  });
  return changed ? { rules: remapped, changed: true } : { rules, changed: false };
};

export const resolveTransitiveRemaps = (remap: Map<string, string>): Map<string, string> => {
  const resolved = new Map<string, string>();
  for (const [source] of remap) {
    const visited = new Set<string>();
    visited.add(source);
    let current = source;
    let next = remap.get(current);
    while (next !== undefined && !visited.has(next)) {
      visited.add(next);
      current = next;
      next = remap.get(current);
    }
    if (current !== source) {
      resolved.set(source, current);
    }
  }
  return resolved;
};

export const remapAndPersistRules = async (sourceTagId: string, destinationTagId: string): Promise<void> => {
  const rules = await getRulesFromCustomXml();
  if (rules.length === 0) return;
  const { rules: remappedRules, changed } = remapTagIdsInRules(rules, sourceTagId, destinationTagId);
  if (!changed) return;
  await persistRulesToCustomXml(remappedRules);
};
